import React, { useContext } from 'react';
import {
  arrayOf, bool, number, shape, string,
} from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { ThumbsUpThumbsDownWithModal } from '@thd-olt-component-react/user-feedback';
import { useStoreId, ExperienceContext } from '@thd-nucleus/experience-context';
import { getMcvisID, getSvocId, getPageType, getPageKey } from '../../../utils/assistant-context-utils';
import { useAssistant } from '../AssistantProvider';
import { getSessionId } from '../../../utils/session-utils';

const MessageFeedback = ({ message }) => {
  const { zipCode, channel } = useContext(ExperienceContext);
  const storeId = useStoreId();
  const { setFeedbackProvided } = useAssistant();
  const pageType = getPageType();

  const handleFeedbackData = () => {
    setFeedbackProvided(message);

    return {
      magicApronAssistant: {
        userContext: {
          userIdentities: {
            mcvisId: getMcvisID(),
            svocId: getSvocId(),
          },
          sessionId: getSessionId(),
          storeId,
          zipCode,
          deviceType: channel === 'mobile' ? 'Mobile' : 'Desktop',
          language: 'en-US',
        },
        pageContext: {
          pageType,
          referrerPage: window.document.referrer,
          timestamp: message?.content?.timestamp,
        },
        responseSummary: message.content?.responseSummary,
        relatedContent: message.content?.relatedContent,
        suggestedQuestions: message.content?.suggestedQuestions,
        followUpQuestions: message.content?.followUpQuestions,
        additionalDetails: message.content?.additionalDetails,
        error: message?.error?.message,
      }
    };
  };

  return (
    <ThumbsUpThumbsDownWithModal
      anchorKey={getPageKey()}
      anchorType={pageType}
      customerInsights="Assistant"
      handleFeedbackData={handleFeedbackData}
      successMessage="Thank you. Your feedback helps us improve."
      thanksMessageHideTime={4000}
    />
  );
};

MessageFeedback.propTypes = {
  message: shape({
    content: shape({
      timestamp: number,
      feedbackProvided: bool,
      relatedContent: shape({
        relatedSearchResults: arrayOf(shape({
          itemId: string,
          price: string,
          imageUrl: string,
          rating: string,
          description: string,
          href: string,
          category: arrayOf(string),
          searchTerm: string
        })),
        recommendations: shape({
          additionalProperties: arrayOf(shape({
            itemId: string,
            price: string,
            averageRating: string,
            imageUrl: string,
            href: string,
            productName: string
          }))
        })
      }),
      suggestedQuestions: arrayOf(string),
      followUpQuestions: arrayOf(string),
      additionalDetails: shape({
        inquiryDetails: shape({
          telephoneNumber: string,
          description: string,
          referenceUrl: string
        })
      })
    })
  }).isRequired,
};

MessageFeedback.defaultProps = {};

MessageFeedback.dataModel = extend(
  ThumbsUpThumbsDownWithModal,
);

export { MessageFeedback };
